// extracted by mini-css-extract-plugin
module.exports = {"faq":"commonPageContent_faq__r3W7x","text-bold":"commonPageContent_text-bold__V2voz","heading":"commonPageContent_heading__PKNiL","content":"commonPageContent_content__uQ4sT"};